import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
/* empty css                     */
function SuggestionBlock({
  title,
  handleSubmit,
  suggestions,
  render
}) {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { className: "suggestion-block" }, /* @__PURE__ */ React.createElement("span", { id: title, className: "suggestion-block__header" }, title), !suggestions || !Array.isArray(suggestions) || suggestions.length === 0 ? /* @__PURE__ */ React.createElement("div", { className: "suggestion-block__no-results" }, getLabel("search.noResults.title")) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("ul", { className: "suggestion-block__results", "aria-label": title }, suggestions.map((suggestion, index) => {
    if (suggestion) {
      const augmentedSuggestion = {
        ...suggestion,
        position: index + 1
      };
      return /* @__PURE__ */ React.createElement("li", { className: "suggestion-block__result", key: augmentedSuggestion.objectID }, render(augmentedSuggestion));
    }
  })), handleSubmit && /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "suggestion-block__show-all",
      type: "button",
      "data-t": title,
      onClick: handleSubmit
    },
    getLabel("search.showAll")
  )));
}
export {
  SuggestionBlock as default
};
//# sourceMappingURL=SuggestionBlock.js.map
